import { get } from '@webapp-next/lib/request/webapp/apiv2';
import { DapContext } from '@/modules/help-center/types/helpCentreContext.d';

export async function getDapContext(): Promise<DapContext> {
  return (await get<DapContext>('/api/v2/onboarding/dap/context')).data;
}
